module.exports = __webpack_public_path__ + "static/media/article-feature-default@2x.876db0bd.jpg";